import { useEffect } from 'react';

interface DocumentMeta {
  /** Full document title, e.g. "Home | Tyler Wrenn". */
  title: string;
  /** Overrides the `<meta name="robots">` content while mounted, restored on unmount. */
  robots?: string;
}

const DEFAULT_ROBOTS = 'index, follow';

/** Set the document title (and optionally the robots meta) for the mounted page. */
export function useDocumentMeta({ title, robots }: DocumentMeta): void {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    if (robots === undefined) return;
    let tag = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'robots';
      document.head.appendChild(tag);
    }
    const previous = tag.content;
    tag.content = robots;
    return () => {
      tag.content = previous || DEFAULT_ROBOTS;
    };
  }, [robots]);
}
